export interface FAQ {
  id: string;
  question: string;
  answer: string;
}

export const faqs: FAQ[] = [
  {
    id: 'faq-1',
    question: '什么是"人妻猎人"？这个标签的来源是什么？',
    answer: '"人妻猎人"是一个源自日本成人亚文化、后在中国社交网络上广泛传播的都市文化标签，用来描述那些有意识、系统性地追求已婚异性（尤其是已婚女性）的个体。该标签最早出现在日本成人影视和漫画领域，大约在2010年前后通过互联网传播进入中国网络空间，并逐渐从小众成人内容讨论圈层溢出至大众社交平台，演变为一个带有社会批判色彩的文化现象描述词。需要说明的是，这一标签本身带有一定的主观判断色彩，并非严格的学术概念。',
  },
  {
    id: 'faq-2',
    question: '婚外情的心理成因有哪些？',
    answer: '婚外情的心理成因是复杂的、多维度的，不能简单归因于"道德败坏"。从个体心理层面看，涉及低冲动控制、感觉寻求倾向、自恋人格特质、童年创伤经历等因素；从关系动力层面看，长期未解决的冲突、情感疏离、性生活不协调、权力失衡等都可能导致一方或双方在婚姻外寻求满足；从社会结构层面看，社交媒体降低了私密交往的门槛，都市匿名性削弱了传统社区监督，当代个人主义文化与婚姻承诺伦理之间存在张力。理解出轨成因的多维性，有助于我们更建设性地思考如何预防和处理这一问题。',
  },
  {
    id: 'faq-3',
    question: '如何判断自己或伴侣是否存在"情感出轨"的风险？',
    answer: '情感出轨的判断边界比身体出轨更为模糊，但有几个关键警示信号：第一，与某位婚外异性分享的心事和秘密超过了与配偶的交流；第二，刻意向配偶隐瞒与该对象的互动（如删除聊天记录）；第三，关系中存在明显的性吸引力或性幻想；第四，越来越多地从婚外对象而非配偶处获取情感支持。一个简单的自我检查方法是：问问自己"我会让配偶看到我与这个人的所有聊天记录吗？"如果答案是否定的，那么这段关系可能已经进入了灰色地带。',
  },
  {
    id: 'faq-4',
    question: '婚外情对子女有什么影响？',
    answer: '父母婚外情对子女的影响是深远的。在短期层面，子女可能出现焦虑、抑郁、愤怒和内疚等复杂情绪，年幼子女尤其容易将父母婚姻问题归咎于自己。在行为层面，青少年子女可能出现学业下滑、社交退缩或叛逆行为增加。更长远的影响体现在子女成年后的亲密关系模式——研究表明，来自父母婚外情家庭的孩子，在自身婚姻中更容易出现信任困难和关系不安全感，形成一定程度的代际传递。因此，无论婚姻最终走向如何，保护子女免受父母冲突的直接伤害至关重要。',
  },
  {
    id: 'faq-5',
    question: '婚外情发生后，婚姻还有修复的可能吗？',
    answer: '婚外情后的婚姻修复虽然困难但并非不可能。成功修复通常需要经历几个关键阶段：首先是危机处理期（完全切断与第三者的联系，建立基本安全协议）；其次是理解与意义建构期（共同检视婚姻中存在的问题，出轨方真诚共情伤害）；最后是重建与深化期（全面透明度、建立新的关系仪式、意义重构）。整个过程通常需要1-3年甚至更长时间。需要强调的是，修复不是"成功"，分开也不是"失败"——每对夫妻都有权根据自己的具体情况做出最适合的选择。寻求专业婚姻咨询师的帮助可以显著提高修复的成功率。',
  },
  {
    id: 'faq-6',
    question: '如何有效预防婚外情的发生？',
    answer: '婚姻危机的预防需要主动投入而非被动等待。三个核心策略：第一，重视"情感账户"的日常充值——每天保持至少15分钟的专注交流，保持积极互动与消极互动至少5:1的比例；第二，建立深入沟通习惯——设立定期的"关系状态检查"，学习使用"我陈述句"表达需求而非指责；第三，建立清晰的边界意识——与伴侣就"什么构成越界"达成共识，警惕情感出轨的前兆信号。记住：长期幸福婚姻不是没有冲突，而是拥有有效处理冲突和维持连接的能力。',
  },
  {
    id: 'faq-7',
    question: '社交媒体对当代婚姻关系有什么影响？',
    answer: '社交媒体对婚姻关系的影响是双面的。消极方面包括：降低了建立私密关系的门槛，使"微量出轨"（如暧昧互动）更容易发生，碎片化了夫妻的共处质量时间，增加了不必要的猜忌来源（如点赞、关注等行为引发的不安全感）。积极方面包括：为异地夫妻提供了便利的沟通工具，使许多夫妻能够更方便地分享日常生活。关键在于夫妻如何主动管理技术使用：建立关于社交媒体边界的共识，保护无干扰的共处时间，以及保持对彼此透明而非秘密的互动模式。',
  },
];